import {
  createDetachedSignature,
  createHash,
  getCertificate,
  getUserCertificates,
} from 'crypto-pro'

export const getAvailableCertificates = async () => {
  console.log('[CERTIFICATE] Начало получения сертификатов')
  try {
    // Проверяем наличие библиотеки crypto-pro через проверку доступности её функций
    const isCryptoProAvailable =
      typeof getUserCertificates === 'function' &&
      typeof getCertificate === 'function' &&
      typeof createHash === 'function'
    console.log('[CERTIFICATE] Проверка доступности crypto-pro:', isCryptoProAvailable)
    const certificates = await getUserCertificates()
    console.log('[CERTIFICATE] Получено сертификатов:', certificates?.length || 0)

    let certificatesWithPrivateKey: any[] = []
    if (!!certificates) {
      certificatesWithPrivateKey = certificates.map(async item => {
        try {
          console.log(`[CERTIFICATE] Проверка сертификата ${item.thumbprint}`)
          console.log(`[CERTIFICATE] Срок действия: с ${item.validFrom} по ${item.validTo}`)

          const currentCertificate = await getCertificate(item.thumbprint)
          if (!currentCertificate) {
            console.error(
              `[CERTIFICATE] Не удалось получить сертификат по thumbprint: ${item.thumbprint}`
            )
            return null
          }

          const privateKey = await currentCertificate?.getCadesProp('FindPrivateKey')
          const hasPrivateKey = await privateKey()
          console.log(`[CERTIFICATE] Наличие приватного ключа: ${!!hasPrivateKey}`)

          if (!hasPrivateKey) {
            console.error(
              `[CERTIFICATE] Отсутствует приватный ключ для сертификата: ${item.thumbprint}`
            )
          }

          return item
        } catch (error: any) {
          console.error('[CERTIFICATE] Ошибка при проверке сертификата:', {
            thumbprint: item.thumbprint,
            error: error.message,
            stack: error.stack,
          })
          return null
        }
      })
    }

    const result = await Promise.all(certificatesWithPrivateKey)
    const validCertificates = result.filter((item: any) => !!item)
    console.log('[CERTIFICATE] Валидных сертификатов:', validCertificates.length)
    return validCertificates
  } catch (error: any) {
    console.error('[CERTIFICATE] Критическая ошибка при получении сертификатов:', {
      message: error.message,
      stack: error.stack,
      name: error.name,
    })
    throw error
  }
}

export const checkECPPrivateKey = async () => {
  try {
    const availableCertificates = await getAvailableCertificates()
    console.log('чекаем ключ')
    if (availableCertificates.length > 0) {
      return true
    } else return false
  } catch (error) {
    console.log(error)
    return false
  }
}

export interface ICertificate {
  id?: number
  value: string
  owner?: string
  active_from: string
  active_to: string
}

export interface ISignObject {
  signature?: string
  certificate: ICertificate
}

export const getUserCertificate = async () => {
  const certificates = await getUserCertificates()
  const thumbprint = certificates[1].thumbprint
  const activeFrom = certificates[1].validFrom
  const activeTo = certificates[1].validTo
  const currentCertificate =
    certificates.length > 0 ? await getCertificate(certificates[1].thumbprint) : undefined
  const ownerInfo = await currentCertificate?.getOwnerInfo()
  const certificateObj: ICertificate = {
    value: thumbprint,
    owner: !!ownerInfo ? `${ownerInfo[0].description} ${ownerInfo[1].description}` : undefined,
    active_from: activeFrom,
    active_to: activeTo,
  }
  return certificateObj
}

export const createSign = async (thumbprint: string, message: string | any) => {
  console.log('[SIGN] Начало создания подписи')
  try {
    console.log('[SIGN] Проверка входных данных:', {
      thumbprintLength: thumbprint?.length,
      messageType: typeof message,
      messageLength: message?.length,
    })

    const hash = await createHash(message)
    console.log('[SIGN] Хеш создан успешно')

    const signature = await createDetachedSignature(thumbprint, hash)
    console.log('[SIGN] Подпись создана успешно')

    return signature
  } catch (error: any) {
    console.error('[SIGN] Ошибка при создании подписи:', {
      thumbprint,
      errorMessage: error.message,
      errorName: error.name,
      errorStack: error.stack,
      errorCode: error.code,
    })
    return null
  }
}
